import { useState, useEffect } from 'react'
import { m } from 'framer-motion'
import { Nav } from './components/Nav'
import { Footer } from './components/Footer'
import { About } from './components/About'
import { Experience } from './components/Experience'
import { Projects } from './components/Projects'
import { ThemeToggle } from './components/ThemeToggle'
import { Signature } from './components/Signature'

export default function App() {
  const [isDark, setIsDark] = useState(true)

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark)
  }, [isDark])

  return (
    <div
      className={`relative min-h-screen overflow-x-clip transition-colors duration-300 grain ${
        isDark ? '' : 'grain-light'
      }`}
      style={{ backgroundColor: isDark ? '#0a0a0a' : '#fafafa' }}
    >
      <a
        href="#about"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-white focus:text-black focus:rounded-md focus:text-sm"
      >
        Skip to content
      </a>

      <main className="relative z-[2] max-w-2xl mx-auto px-6 lg:px-8">
        <Nav isDark={isDark}>
          <ThemeToggle isDark={isDark} onToggle={() => setIsDark(!isDark)} />
        </Nav>

        {/* Hero — handwriting for the name, mono for the role.
            The role line is data, so it gets the label treatment. */}
        {/* pb is a chapter break (identity → content): 112 / 144, deliberately
            larger than the 80 / 96 between peer sections below. */}
        <section className="pt-10 pb-28 sm:pt-14 sm:pb-36">
          {/* The visual wordmark is traced SVG, so the h1 carries the name as
              real text for crawlers and screen readers while the signature
              itself is decorative. */}
          <m.h1
            className="-ml-1"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            /* No delay: the wordmark is the first thing that should resolve. */
            transition={{ duration: 0.5 }}
          >
            <span className="sr-only">
              Franco Cirulli — Software Developer &amp; Product Designer
            </span>
            <Signature
              /* max-w-full + h-auto lets the viewBox scale down on narrow
                 screens instead of being clipped by overflow-x-clip */
              className="h-auto max-w-full"
              text="Franco Cirulli"
              fontSize={26}
              color={isDark ? '#e5e5e5' : '#171717'}
              duration={1}
              delay={0.1}
            />
          </m.h1>
          <m.p
            className={`u-label mt-1 transition-colors ${
              isDark ? 'text-neutral-500' : 'text-neutral-500'
            }`}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.35 }}
          >
            software developer
            <span className={isDark ? 'text-neutral-700' : 'text-neutral-300'}>
              {' · '}
            </span>
            product designer
          </m.p>
        </section>

        {/* Content Sections — separated by space, not by rules */}
        <About isDark={isDark} />
        <Experience isDark={isDark} />
        <Projects isDark={isDark} />

        <Footer isDark={isDark} />
      </main>
    </div>
  )
}
